import { Box, Button, Grid, Typography } from '@mui/material';
import FormsPopup from '../../common/FormsPopup/FormsPopup';
import InputField from '../../common/InputField/InputField';
import UserAvatar from '../../common/UserAvatar/UserAvatar';
import styles from './styles';
import { EditPartnerProps } from './types';

const EditPartner = ({ setEditPartner, setViewPartner, editPartner, rowPartnerData }: EditPartnerProps) => {
    return (
        <FormsPopup
            id="edit_partner"
            open={editPartner}
            title="Edit Partner"
            textAlign="left"
            handleClose={() => setEditPartner(false)}
            width={662}
        >
            <>
                <Box>
                    <Typography id="edit_partner_title" component="div" sx={styles.subHeadText}>
                        Inform all requested information below to create a new partner.Once confirmed, new members will
                        be allowed to register
                    </Typography>
                </Box>
                <Box component="form" noValidate id="edit-partner">
                    <Grid container spacing={2} sx={styles.container}>
                        <Typography component="div" sx={styles.partnerImage}>
                            <UserAvatar
                                name={rowPartnerData?.name || ''}
                                source={
                                    rowPartnerData?.logoUrl && rowPartnerData?.logoUrl !== 'null'
                                        ? rowPartnerData?.logoUrl
                                        : ''
                                }
                                size={70}
                                radius="8px"
                                fontSize={20}
                                id="partner_icon"
                            />

                            <Typography component="div" sx={styles.partnerName}>
                                <InputField
                                    id="completeName"
                                    label="Complete Name"
                                    type="text"
                                    name="name"
                                    placeholder="Type here..."
                                    disabled
                                    value={`${rowPartnerData?.name}`}
                                />
                            </Typography>
                        </Typography>

                        <Typography component="div" sx={styles.partnerField}>
                            <InputField
                                id="email"
                                label="Email"
                                type="email"
                                name="email"
                                placeholder="Type here..."
                                disabled
                                value={`${rowPartnerData?.email}`}
                            />
                        </Typography>
                        <Typography component="div" sx={styles.partnerField}>
                            <InputField
                                id="partnerUniqueId"
                                label="Partner Uniq Id"
                                type="text"
                                name="uniqueId"
                                placeholder="Type here..."
                                disabled
                                value={`${rowPartnerData?.uniqueId}`}
                            />
                        </Typography>
                    </Grid>

                    <Typography component="div">
                        <Button id="passwordLink" variant="text" sx={styles.sendUniqueId}>
                            Resend Unique Id To Members
                        </Button>
                        <Button
                            variant="contained"
                            sx={styles.editPartner}
                            onClick={() => {
                                setViewPartner(false);
                                setEditPartner(false);
                            }}
                            id="saveChanges"
                        >
                            Save Changes
                        </Button>
                    </Typography>
                </Box>
            </>
        </FormsPopup>
    );
};
export default EditPartner;
